import { SettingConst } from '../../types';

/**
 * Holidays for Phone in different countries
 */
export const HELP_CENTER_PHONE_HOLIDAYS =
  'HELP_CENTER_PHONE_HOLIDAYS' as SettingConst<
    'HELP_CENTER_PHONE_HOLIDAYS',
    Array<number>,
    'HELP_CENTER' | 'RETAILER_IOS' | 'RETAILER_ANDROID'
  >;
